const STYLES = {
  awaiting_payment: ["Awaiting payment", "bg-amber-50 text-amber-800 border-amber-200 dark:bg-amber-950/40 dark:text-amber-300 dark:border-amber-900"],
  pending_claim: ["Delivered · awaiting claim", "bg-sky-50 text-sky-800 border-sky-200 dark:bg-sky-950/40 dark:text-sky-300 dark:border-sky-900"],
  claimed: ["Claimed", "bg-emerald-50 text-emerald-800 border-emerald-200 dark:bg-emerald-950/40 dark:text-emerald-300 dark:border-emerald-900"],
  returned: ["Returned to sender", "bg-red-50 text-red-700 border-red-200 dark:bg-red-950/40 dark:text-red-300 dark:border-red-900"],
  erased: ["Erased", "bg-slate-100 text-slate-500 border-slate-200 dark:bg-slate-800 dark:text-slate-400 dark:border-slate-700"],
};

export const StatusBadge = ({ status, testId }) => {
  const [label, cls] = STYLES[status] || [status, "bg-slate-100 text-slate-700 border-slate-200"];
  return (
    <span data-testid={testId || `status-badge-${status}`} className={`inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-md text-xs font-medium border whitespace-nowrap ${cls}`}>
      <span className="h-1.5 w-1.5 rounded-full bg-current" />
      {label}
    </span>
  );
};
